import { Box, Typography, Card, CardContent, Chip } from "@mui/material";
import useResponsive from "../../Hooks/useResponsive";
import { memo, useEffect, useState } from "react";
import SessionCountAndDetails from "./SessionCountAndDetails";

const LeadDetails = ({ leadDetails, seletctedSubEnrollmentId }) => {
  const mdDown = useResponsive("down", "md");
  const [direction, setDirection] = useState("row");

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  return (
    <Box>
      <Box
        display="flex"
        flexWrap={"wrap"}
        justifyContent="space-between"
        p={2}
        sx={{
          gap: 1,
          px: 3,
          background:
            "linear-gradient(135deg, rgb(115 207 253), rgb(210 239 254))",
          borderRadius: 10, // more rounded corners
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // subtle shadow
        }}
      >
        <Chip
          variant="outlined"
          label={`Name : ${leadDetails?.lead_name}`}
          sx={{
            backgroundColor: "white",
            color: "#000000",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        />
        <Chip
          variant="outlined"
          label={`Admission Id : ${leadDetails?.admn_no}`}
          sx={{
            backgroundColor: "white",
            color: "#000000",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        />

        <Chip
          variant="outlined"
          label={`Course : ${leadDetails?.course_name}`}
          sx={{
            backgroundColor: "white",
            color: "#000000",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        />
        <Chip
          variant="outlined"
          label={`Subject : ${leadDetails?.subject_name}`}
          sx={{
            backgroundColor: "white",
            color: "#000000",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        />
        <Chip
          variant="outlined"
          label={
            <span>
             <SessionCountAndDetails seletctedSubEnrollmentId={seletctedSubEnrollmentId} />
            </span>
          }
          sx={{
            backgroundColor: "white",
            color: "#000000",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        />
      </Box>
    </Box>
  );
};

export default memo(LeadDetails);
